<template>
  <div>
    <div id="bom-review-page" class="content">
      <div class="header">
        <h1>{{ pageTitle }}</h1>
        <h2>
          <Button id="bom-review-return" type="primary" @click="handleReturn">{{ $t('form.return')}}</Button>
          <Button id="bom-review-export" disabled>{{ $t('bom_tool.review.actions.export') }}</Button>
          <BomVersionSelect
            :bomId="bom ? bom.id : false"
            :clearable="false"
            @updateVersionList="handleVersionListChange"
            @versionSelected="handleSelectVersion"
            style="width:200px"
            id="bom-review-version-select"
            ref="versionSelect" />
        </h2>
      </div>
    </div>
    <BOMReviewTable
      :rows="rows"
      :columns="columns"
      :bomVersion="selectedVersion"
      :loadingVersion="loadingVersion"></BOMReviewTable>
  </div>
</template>

<script>
import BOMReviewTable from './components/widgets/bom-review-table'
import BomVersionSelect from './versions/bom-versions-select'
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'BOMPreview',
  components: {
    BOMReviewTable,
    BomVersionSelect
  },
  data () {
    return {
      loadingFileContents: false,
      loadingVersion: true,
      selectedVersion: {},
      versions: []
    }
  },
  computed: {
    ...mapGetters([
      'customerBomFile',
      'customerBomFileWithVersion'
    ]),
    rows () {
      return this.customerBomFileWithVersion?.rows || []
    },
    columns () {
      return this.customerBomFileWithVersion?.header_mapping || {}
    },
    bom () {
      return this.customerBomFile?.bom || {}
    },
    pageTitle () {
      document.title = this.$t('menu.bom.review')
      return document.title
    }
  },
  created () {
    this.loadCustomerBomFileContents(this.$route.params.fileId)
  },
  methods: {
    ...mapActions([
      'getCustomerBomFile',
      'getCustomerBomFileWithVersion'
    ]),
    handleVersionListChange (data) {
      this.versions = data
      if (data.length > 0) {
        this.loadingVersion = false
        this.selectedVersion = {
          version_id: data[0].version_id,
          version: data[0].version
        }
        this.$refs.versionSelect.setSelectedVersion(data[0].version)
        this.loadCustomerBomFileContentsWithVersion(this.$route.params.fileId, data[0].version)
      }
    },
    handleSelectVersion (data) {
      if (data !== null) {
        this.selectedVersion = {
          version_id: data.version_id,
          version: data.version
        }
        this.loadCustomerBomFileContentsWithVersion(this.$route.params.fileId, data.version)
      }
    },
    loadCustomerBomFileContents (fileId) {
      this.loadingFileContents = true
      // Get the contents of the customer BOM file stored.
      this.getCustomerBomFile(fileId).finally(() => {
        this.loadingFileContents = false
      })
    },
    loadCustomerBomFileContentsWithVersion (fileId, version) {
      this.loadingVersion = true
      this.getCustomerBomFileWithVersion({ fileId, version }).finally(() => {
        this.loadingVersion = false
      })
    },
    handleReturn () {
      this.$router.push({
        name: 'menu.bom.view',
        params: {
          bomId: this.bom?.id
        },
        query: {
          rootBomId: this.bom?.id
        }
      })
    }
  },
  watch: {
    '$route.params.fileId': function (fileId) {
      this.loadCustomerBomFileContents(fileId)
    }
  }
}
</script>

<style lang="less">
.content {
  overflow: auto;
  padding: 10px 30px;
}
#bom-review-page {
  overflow: visible;
  .bom-tool-link { float: right; }
}
#bom-review-return, #bom-review-export, #bom-review-version-select {
  float: right;
  font-weight: normal;
}
#bom-review-export, #bom-review-version-select {
  margin-right: 10px;
}
.content-wrapper, .main-layout-con.ivu-layout {
  overflow: hidden!important;
}
</style>
